import _ from 'underscore'

_.mixin(require('underscore.inflections'));
